import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import {
	DATABOX_FOLDER_LABELS,
	DataBoxFolderType,
	useDataBoxMessageDetailContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { ConnectToAnotherSubmissionDialog } from '../../Page/moje-podani/detail/ConnectToAnotherSubmission';
import { DisconnectFromSubmissionDialog } from '../../Page/moje-podani/detail/DisconnectFromSubmission';
import { DataBoxMessageConfirmModal } from './DataBoxMessageConfirmModal';
import { DataBoxMessageDetailPageSkeleton } from './DataBoxMessageDetailPageSkeleton';
import { DataBoxMessageOverview } from './DataBoxMessageOverview';
import { DataBoxMessageVaultConfirmModal } from './DataBoxMessageVaultConfirmModal';
import { MessageActionButton } from './MessageActionButton';

export const DataBoxMessageDetailPage = () => {
	const { t } = useLocale(PageCode['datove-schranky']);
	const navigate = useNavigate();

	const {
		dataBoxId,
		folderType,
		messageId,
		isLoading,
		message,
		disableNewMessageButton,
		mySubmissionConnection,
	} = useDataBoxMessageDetailContext();

	if (isLoading || mySubmissionConnection.isLoading) {
		return <DataBoxMessageDetailPageSkeleton />;
	}

	if (!message) {
		return (
			<section className="flex flex-col grow h-full bg-(--background-block-primary) p-4 [ md:rounded-3xl ]">
				<Button
					onClick={() =>
						navigate(
							pageRouteResolver('datove-schranky.schranka', {
								dataBoxId,
								folderType,
							})
						)
					}
					color="primary"
					type="base"
					size="m"
					className="[ ds:hidden! ]"
					aria-label={t(DATABOX_FOLDER_LABELS[folderType])}
					iconStart={
						<GovIcon
							name="chevron-left"
							type="components"
						/>
					}>
					{t(DATABOX_FOLDER_LABELS[folderType])}
				</Button>

				<p>{t('zpravy.zpravu-nepodarilo-nacist')}</p>
			</section>
		);
	}

	return (
		<section className="flex flex-col justify-between grow h-full mt-auto bg-(--background-block-primary) overflow-hidden [ md:rounded-3xl ]">
			<div className="flex flex-col justify-between w-full h-full">
				<DataBoxMessageOverview message={message} />
				<footer className="ds-message-footer flex justify-between items-center gap-4 mt-auto p-(--templates-margin-l) border-t border-(--border-subtlest) bg-(--background-block-primary) [ xl:rounded-b-2xl ]">
					<MessageActionButton />

					{folderType !== DataBoxFolderType.Trash ? (
						message.prijemceId === dataBoxId ? (
							<Button
								color="primary"
								type="base"
								size="s"
								onClick={() =>
									navigate(
										pageRouteResolver(
											'datove-schranky.schranka.zprava.odpoved',
											{
												dataBoxId,
												folderType,
												messageId,
											}
										)
									)
								}
								className="ml-auto"
								isDisabled={disableNewMessageButton}
								aria-label={t('zpravy.detail.odpovedet')}
								iconStart={
									<GovIcon
										name="arrow-90deg-left"
										type="templates"
									/>
								}>
								{t('zpravy.detail.odpovedet')}
							</Button>
						) : (
							<Button
								color="primary"
								type="base"
								size="s"
								onClick={() =>
									navigate(
										pageRouteResolver('datove-schranky.schranka.zprava.dalsi', {
											dataBoxId,
											folderType,
											messageId,
										})
									)
								}
								className="ml-auto"
								isDisabled={disableNewMessageButton}
								aria-label={t('zpravy.detail.odeslat-dalsi')}
								iconStart={
									<GovIcon
										name="reply"
										type="templates"
									/>
								}>
								{t('zpravy.detail.odeslat-dalsi')}
							</Button>
						)
					) : null}
				</footer>
			</div>
			<DataBoxMessageConfirmModal />
			<DataBoxMessageVaultConfirmModal />
			<ConnectToAnotherSubmissionDialog {...mySubmissionConnection.connect} />
			<DisconnectFromSubmissionDialog {...mySubmissionConnection.disconnect} />
		</section>
	);
};
